<template>
	<div class="copyrights">
		<span v-for="(copyright, c) in copyrights" :key="'copyright' + c" class="copyright">			
			<span class="copyright__images">
				<span class="names">
					<span v-for="(name, n) in copyright.names" class="name" :key="copyright.author + n + name">{{name}}</span>
				</span>
			</span>
			<span class="copyright__author">
				{{copyright.author}}
			</span>
		</span>
	</div>
</template>
<script>
	export default {
		name: 'Copyrights',
		props: {
			images: {
				type: Array,
				required: true
			}
		},
		computed: {
			copyrights: function() {
				let copyrights = []
				this.images.map(image => {
					let thisAuthor = copyrights.find(c => c.author == image.author)
					if (thisAuthor === undefined) {
						thisAuthor = {
							author: image.author,
							names: []
						}
						copyrights.push(thisAuthor)
					}
					thisAuthor.names.push(image.name)
				})

				return copyrights
			},
		}
	}
</script>
<style lang="scss">
	@import 'global/css/contexte.apps';
	@import 'global/css/contexte.apps.colors';
	.copyrights {
		position: relative;
		padding-left: 5em;
		font-size: .8em;
		opacity: .8;
		&::before {
			left: 0;
			top: 1px;
			text-transform: uppercase;
			font-size: .9em;
			color: $another-grey;
			position: absolute;
			content: 'Images';
		}
	}
	.copyright {
		&__images {
			&::after {
				content: ':';
				margin-left: .2em;
			}
		}
		&:not(:last-child) {			
			.copyright__author {
				&::after {
					content: '●';
					color: $red;
					margin-right: .3em;
				}
			}
		}
	}
	.name {
		@include textlist()
	}
</style>